import { FormInputMeta } from '@Modules/core/types/FormMetaType';
import { getValidationSchema } from '@Shared/utils/validationSchema';
import * as yup from "yup";


export interface ISalaryFileDetailsFormMeta {
  idBatch: FormInputMeta,
  company: FormInputMeta,
  startDate: FormInputMeta,
  endDate: FormInputMeta,
  operationType: FormInputMeta,
  status: FormInputMeta,

  nameCompany: FormInputMeta,
  addressCompany: FormInputMeta,
  nameHolder: FormInputMeta,
  addressClient: FormInputMeta,
  salary: FormInputMeta,
  companyHolderNumber: FormInputMeta,
  telephone: FormInputMeta,
  
  // Schema
  schema: any,
}

const SalaryFileDetailsFormMeta = {} as ISalaryFileDetailsFormMeta;

SalaryFileDetailsFormMeta.idBatch = {
  name: 'idBatch',
  type: 'select',
  label: 'Batch ID',
  options:  [
    {
      label: 'Batch ID A',
      value: 'a'
    },
    {
      label: 'Batch ID B',
      value: 'b',
    },
    {
      label: 'Batch ID C',
      value: 'b',
    },
  ],
  validation: yup.string().required(),
};
SalaryFileDetailsFormMeta.startDate = {
  name: 'startDate',
  type: 'date',
  label: 'Date traitement du',
  placeholder: '',
  validation: yup.string().required(),
};

SalaryFileDetailsFormMeta.endDate = {
  name: 'endDate',
  type: 'date',
  label: 'Au',
  placeholder: '',
  validation: yup.string().required(),
};

SalaryFileDetailsFormMeta.company = {
  name: 'company',
  type: 'select',
  label: 'Entreprise',
  options:  [
    {
      label: 'Entreprise A',
      value: 'a'
    },
    {
      label: 'Entreprise B',
      value: 'b',
    },
    {
      label: 'Entreprise C',
      value: 'b',
    },
  ],
  validation: yup.string().required(),
};

SalaryFileDetailsFormMeta.operationType = {
  name: 'operationType',
  type: 'select',
  label: 'Type Operation',
  options:  [
    {
      label: 'Type Operation A',
      value: 'a'
    },
    {
      label: 'Type Operation B',
      value: 'b',
    },
    {
      label: 'Type Operation C',
      value: 'b',
    },
  ],
  validation: yup.string().required(),
};

SalaryFileDetailsFormMeta.status = {
  name: 'status',
  type: 'select',
  label: 'Statut',
  options:  [
    {
      label: 'Statut A',
      value: 'a'
    },
    {
      label: 'Statut B',
      value: 'b',
    },
    {
      label: 'Statut C',
      value: 'b',
    },
  ],
  validation: yup.string().required(),
};


SalaryFileDetailsFormMeta.nameCompany = {
  name: 'nameCompany',
  type: 'text',
  label: 'Nom Entreprise',
  placeholder: '',
  validation: yup.string().required(),
};
SalaryFileDetailsFormMeta.addressCompany = {
  name: 'addressCompany',
  type: 'text',
  label: 'Adresse Entreprise',
  placeholder: '',
  validation: yup.string().required(),
};
SalaryFileDetailsFormMeta.nameHolder = {
  name: 'nameHolder',
  type: 'text',
  label: 'Nom Porteur',
  placeholder: '',
  validation: yup.string().required(),
};
SalaryFileDetailsFormMeta.addressClient = {
  name: 'addressClient',
  type: 'text',
  label: 'Adresse client',
  placeholder: '',
  validation: yup.string().required(),
};
SalaryFileDetailsFormMeta.salary = {
  name: 'salary',
  type: 'text',
  label: 'Salaire',
  placeholder: '',
  validation: yup.string().required(),
};
SalaryFileDetailsFormMeta.companyHolderNumber = {
  name: 'companyHolderNumber',
  type: 'text',
  label: 'N° porteur société',
  placeholder: '',
  validation: yup.string().required(),
};
SalaryFileDetailsFormMeta.telephone = {
  name: 'telephone',
  type: 'text',
  label: 'Telephone',
  placeholder: '',
  validation: yup.string().required(),
};


SalaryFileDetailsFormMeta.schema = yup.object().shape(getValidationSchema(SalaryFileDetailsFormMeta));

export default SalaryFileDetailsFormMeta;